function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 40,
  height: 40,
  rx: 16,
  fill: "#CCF5FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5 10L26.5 10.01C27.61 10.01 28.5 10.89 28.5 12V28C28.5 29.11 27.61 30 26.5 30H14.5C13.39 30 12.5 29.11 12.5 28V12C12.5 10.89 13.39 10 14.5 10ZM14.5 28H26.5V12H14.49L14.5 28ZM16.5 13C15.9477 13 15.5 13.4477 15.5 14C15.5 14.5523 15.9477 15 16.5 15C17.0523 15 17.5 14.5523 17.5 14C17.5 13.4477 17.0523 13 16.5 13ZM18.5 14C18.5 13.4477 18.9477 13 19.5 13C20.0523 13 20.5 13.4477 20.5 14C20.5 14.5523 20.0523 15 19.5 15C18.9477 15 18.5 14.5523 18.5 14ZM20.5 27C23.26 27 25.5 24.76 25.5 22C25.5 19.24 23.26 17 20.5 17C17.74 17 15.5 19.24 15.5 22C15.5 24.76 17.74 27 20.5 27ZM22.8601 24.36C24.1601 23.06 24.1601 20.94 22.8601 19.64L18.1401 24.36C19.4401 25.66 21.5601 25.66 22.8601 24.36Z",
  fill: "#121221"
});

function SvgLaundry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/Laundry.ebe373d5.svg";
export { ForwardRef as ReactComponent };